<template>
	<div class="module_page page_content institution" aria-label="Institution Details view content page">
	  <div class="row page-heading">
	    <div class="col-6 input module_heading" role="heading" aria-level="1">
	      <span class="module_icon ic-inst"></span>
	      <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
	    </div>
	    <div class="col-6 btn_container">
	      <template v-if="isSuperAdmin">
		      <b-btn @click="assignAssociatedInstitutions">assign associated institutions</b-btn>
		    </template>
				<b-btn @click="editDetailsClicked">edit</b-btn>
	    </div>
    </div>
	  <div class="page_content_container">
	    <institution-menu :uuid="uuid" :active="'details'"></institution-menu>
	    <div class="row pg_content">
	      <div class="col-12">
	        <div class="row">
	          <div class="col-12 pg_fld_sec">
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label">Institution Name</label>
	                    </div>
	                    <div class="fld_input">
	                      <label class="val"> {{institution.displayName}} </label>
	                    </div>
	                  </div>
	                </div>
	                <div class="row" style="margin-top: 30px;">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label" for="institutionLevel">Level</label>
	                    </div>
	                    <div class="fld_input">
	                      <label class="val">{{institution.level}}</label>
	                    </div>
	                  </div>
	                </div>
	                <div class="row" style="margin-top: 30px;">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label" for="institutionLevel">Enhanced Widget</label>
	                    </div>
	                    <div class="fld_input">
	                      <label class="val">{{institution.enhancedWidget}}</label>
	                    </div>
	                  </div>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label">Description</label>
	                    </div>
	                    <div class="fld_input">
	                      <label class="val description">{{institution.description}}</label>
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="institutionType">Type</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.type}}</label>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="institutionType">Org Type</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.orgType}}</label>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">URL</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.uri}}</label>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">SSO URL </label>
	                </div>
	                <div class="fld_input">
	                  <label class="val"> {{institution.ssoUrl}}</label>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="path">SSO Path </label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.path}}</label>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="path">SSO Logout Url </label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.ssoLogoutUrl}}</label>
	                </div>
	              </div>
	            </div>

              <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="path">Alert Email</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.alertEmail}}</label>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="path">State </label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.state}}</label>
	                </div>
	              </div>
	          </div>
              <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="path">Partner Home Url </label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.partnerHomeUrl}}</label>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="path">Orientation Course Enrollment Emails</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.orientationEnrollmentEmail}}</label>
	                </div>
	              </div>
	          </div>

              <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="path">Support Name </label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.supportName}}</label>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Support Email </label>
	                </div>
	                <div class="fld_input">
	                  <label class="val"> {{institution.supportEmail}}</label>
	                </div>
	              </div>
	            </div>
              <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Employer Support Name</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.employerSupportName}}</label>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Employer Support Email</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.employerSupportEmail}}</label>
	                </div>
	              </div>
	            </div>
              <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Employer Phone</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.employerPhone}}</label>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Employer Fax</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.employerFax}}</label>
	                </div>
	              </div>
	            </div>
              <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="path">Item Analysis Report</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val" v-if="institution.sendItemAnalysisReport">Enabled</label>
	                  <label class="val" v-else>Disabled</label>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Item Analysis Report Emails </label>
	                </div>
	                <div class="fld_input">
	                  <label class="val"> {{institution.itemAnalysisReportEmails}}</label>
	                </div>
	              </div>
	            </div>

	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="path">Redirect URL after SSO </label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.redirectUrl}}</label>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="shortName">Short Name</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.shortName}}</label>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="institutionType">Parent Open Id</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.parentOpenId}}</label>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Open Id</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val"> {{institution.openId}}</label>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="institutionType">Phone No.</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val">{{institution.phonenumber}}</label>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Fax No.</label>
	                </div>
	                <div class="fld_input">
	                  <label class="val"> {{institution.faxnumber}}</label>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row" style="margin-top: 30px;">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label" for="institutionType">Address</label>
	                    </div>
	                    <div class="fld_input">
	                      <label class="val">{{institution.address}}</label>
	                    </div>
	                  </div>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label">Logo</label>
	                    </div>
	                    <div class="fld_input">
	                      <div class="thumbnail_container">
	                        <img v-if="institution.logo" id="institutionThumbnail" class="thumbnail_image" :src="institution.logo" />
	                        <span v-else class="ic ico-buildingCollege"></span>
	                      </div>
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Self Registration Custom Text</label>
	                </div>
	                <div class="fld_input">
	                	<div class="text-area p-2" v-html="institution.selfRegistrationMessage"></div>
	                </div>
	              </div>
	            </div>
              <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Refund Policy Link</label>
	                </div>
	                <div class="fld_input">
	                	<label class="val">{{institution.refundPolicyLink}}</label>
	                </div>
	              </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Refund Policy</label>
	                </div>
	                <div class="fld_input">
	                	<div class="text-area p-2" v-html="institution.refundPolicy"></div>
	                </div>
	              </div>
	            </div>
              <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Purchase Expiration Custom Text</label>
	                </div>
	                <div class="fld_input">
	                	<div class="text-area p-2" v-html="institution.purchaseExpirationMessage"></div>
	                </div>
	              </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Privacy Policy Link</label>
	                </div>
	                <div class="fld_input">
	                	<div class="text-area p-2" v-if="institution.privacyPolicyLink"><a :href="institution.privacyPolicyLink" target="_blank">{{institution.privacyPolicyLink}}</a></div>
	                </div>
	              </div>
	            </div>
              <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Buy Flow Custom Message</label>
	                </div>
	                <div class="fld_input">
	                	<div class="text-area p-2" v-html="institution.buyFlowMessage"></div>
	                </div>
	              </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Learn More Flow Custom Message</label>
	                </div>
	                <div class="fld_input">
	                	<div class="text-area p-2" v-html="institution.learnFlowMessage"></div>
	                </div>
	              </div>
	            </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">User Suspension Message</label>
	                </div>
	                <div class="fld_input">
	                	<div class="text-area p-2" v-html="institution.userSuspensionMessage"></div>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row" style="margin-top: 30px;">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label" for="learnerDashboard">Learner Dashboard Path</label>
	                    </div>
	                    <div class="fld_input">
	                      <label class="val">{{institution.learnerDashboard}}</label>
	                    </div>
	                  </div>
	                </div>
	                <div class="row" style="margin-top: 30px;">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label" for="invoicePaymentLink">Invoice Payment Link</label>
	                    </div>
	                    <div class="fld_input">
	                      <label class="val">{{institution.invoicePaymentLink}}</label>
	                    </div>
	                  </div>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label">Learner Dashboard Background</label>
	                    </div>
	                    <div class="fld_input">
	                      <div class="thumbnail_container">
	                        <img id="dashboardBgImage" class="thumbnail_image" :src="institution.dashboardBgImage" />
	                      </div>
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row" style="margin-top: 30px;">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label" for="locationMapEmbbedURL">locationMapEmbbedURL</label>
	                    </div>
	                    <div class="fld_input">
	                      <label class="val">{{institution.locationMapEmbbedURL}}</label>
	                    </div>
	                  </div>
	                </div>

	              </div>
	            </div>

	          </div>

	          <!-- .pg_fld_sec -->
	        </div>
	      </div>
	      <!-- .dasboard-left-section -->
	    </div>
	  </div>
	  <!-- .page-content -->
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionHeader from './InstitutionHeader'

export default {
  name: 'institutionDetails',
  props: ['uuid'],
  components: {
    InstitutionMenu,
    InstitutionHeader
  },
  data: () => {
    return {
      uObj: JSON.parse(localStorage.getItem('userobj')),
      userrole: localStorage.getItem('userrole'),
      superAdminPermissionName: 'SUPERADMIN_PERMISSION'
    }
  },
  mounted () {
    this.loadInstitution()
  },
  methods: {
    ...mapActions([
      'loadInstitutionDetail',
      'loadUserAdvisor',
      'loadLogDashboardActivity'
    ]),
    loadInstitution () {
      this.loadLogDashboardActivity({action: 'viewInstitutionDetailsView', page: 'institutionDetailsView', link: '', entityUuid: this.uuid})
      this.loadInstitutionDetail(this.uuid)
    },
    editDetailsClicked () {
      return this.$router.push({ name: 'editInstitutionDetails', params: { uuid: this.uuid } })
    },
    assignAssociatedInstitutions () {
      return this.$router.push({ name: 'assignAssociatedInstitutions', params: { uuid: this.uuid } })
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution
    }),
    isSuperAdmin () {
      let userObject = JSON.parse(localStorage.getItem('userobj'))
      let permission = userObject.permission || this.permission
      return permission.name === this.superAdminPermissionName
    }
  }
}
</script>

<style scoped>
	div.text-area {
    width: 100%;
    height: 125px;
    overflow: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionDetails.vue